import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { initialFilterState } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter.consts';
import { SearchType } from '@/types/most-search-type';

const consultationModalities: SearchType[] = [SearchType.PRESENTIAL_CONSULTATION, SearchType.ONLINE_CONSULTATION];

export type AvailableSearchFilters = Partial<
  Pick<
    FilterState,
    | 'distance'
    | 'ageGroup'
    | 'dayTime'
    | 'professionalGender'
    | 'followUp'
    | 'onlyScheduled'
    | 'minDate'
    | 'maxDate'
  >
>;

function isConsultationModality(modality: SearchType): boolean {
  return consultationModalities.includes(modality);
}

export function isAgeGroupFilterAvailable(modality: SearchType): boolean {
  return isConsultationModality(modality);
}

export function isProfessionalGenderFilterAvailable(modality: SearchType): boolean {
  return isConsultationModality(modality);
}

export function isDistanceFilterAvailable(modality: SearchType): boolean {
  return modality !== SearchType.ONLINE_CONSULTATION;
}

export function isBookingPreferencesFilterAvailable(modality: SearchType): boolean {
  return isConsultationModality(modality);
}

export function isDateFilterAvailable(_modality: SearchType): boolean {
  return true;
}

export function getClearableFilters(modality: SearchType): Partial<FilterState> {
  const { orderBy, dayTime, distance, ageGroup, professionalGender, followUp, onlyScheduled, minDate, maxDate }
    = initialFilterState;

  return {
    orderBy,
    dayTime,
    ...(isDistanceFilterAvailable(modality) ? { distance } : {}),
    ...(isAgeGroupFilterAvailable(modality) ? { ageGroup } : {}),
    ...(isProfessionalGenderFilterAvailable(modality) ? { professionalGender } : {}),
    ...(isBookingPreferencesFilterAvailable(modality) ? { followUp, onlyScheduled } : {}),
    ...(isDateFilterAvailable(modality) ? { minDate, maxDate } : {}),
  };
}

export function getAvailableFilters(filters: FilterState, modality: SearchType): AvailableSearchFilters {
  const hasDate = isDateFilterAvailable(modality);

  return {
    distance: isDistanceFilterAvailable(modality) ? filters.distance : undefined,
    ageGroup: isAgeGroupFilterAvailable(modality) ? filters.ageGroup : undefined,
    dayTime: filters.dayTime,
    professionalGender: isProfessionalGenderFilterAvailable(modality) ? filters.professionalGender : undefined,
    followUp: isBookingPreferencesFilterAvailable(modality) ? filters.followUp : undefined,
    onlyScheduled: isBookingPreferencesFilterAvailable(modality) ? filters.onlyScheduled : undefined,
    minDate: hasDate ? filters.minDate : undefined,
    maxDate: hasDate ? filters.maxDate : undefined,
  };
}
